import { z } from 'zod';

// Messages from the user to the parent
export const UserReady = 'UserReady'; // Message sent telling parent we are ready to receive messages
export const PreloaderComplete = 'PreloaderComplete'; // Message sent telling parent the box has been revealed
export const BoxRevealComplete = 'BoxRevealComplete'; // Message sent telling parent the box has been revealed
export const PackRevealComplete = 'PackRevealComplete'; // Message sent telling parent the pack has been revealed
export const CardRevealComplete = 'CardRevealComplete'; // Message sent telling parent the card has been revealed
export const GoldenTicketRevealComplete = 'GoldenTicketRevealComplete'; // Message sent telling parent the golden ticket has been revealed

export const AsyncRipPackComplete = 'AsyncRipPackComplete'; // Message sent telling parent the async rip pack has been revealed
export const AsyncListView = 'AsyncListView'; // Message sent telling parent the async list viewer has been revealed
export const AsyncGridView = 'AsyncGridView'; // Message sent telling parent the async grid viewer has been revealed
export const AsyncCardDetailView = 'AsyncCardDetailView'; // Message sent telling parent the async card detail viewer has been revealed
export const AsyncBtnClick = 'AsyncBtnClick'; // Message sent telling parent the async button has been clicked. Could be sell back, view collection, select another pack, etc.

export const CloseExperience = 'CloseExperience'; // Message sent telling parent to close the async experience

// Messages from the parent to the user
export const Setup = 'Setup'; // Incoming message with setup information including user, box, step and current card.
export const UnlockAudio = 'UnlockAudio'; // Incoming message to unlock the audio
export const SetAudioEnabled = 'SetAudioEnabled'; // Incoming message to set IR audio enabled state.
export const UpdateStep = 'UpdateStep'; // Incoming message to indicate the current step in the process. Should be one of steps.js.
export const UpdateCard = 'UpdateCard'; // Incoming message to update the state of the card. Could be index, revealed, rotation, flip, etc. Should include all the information
export const UpdateGoldenTicket = 'UpdateGoldenTicket'; // Incoming message to update the state of a golden ticket. Could be revealed, etc.
export const Complete = 'Complete';

export const MESSAGES = z.enum([
    UserReady,
    PreloaderComplete,
    BoxRevealComplete,
    PackRevealComplete,
    CardRevealComplete,
    GoldenTicketRevealComplete,
    AsyncRipPackComplete,
    AsyncListView,
    AsyncGridView,
    AsyncCardDetailView,
    AsyncBtnClick,
    CloseExperience,
    Setup,
    UnlockAudio,
    SetAudioEnabled,
    UpdateStep,
    UpdateCard,
    UpdateGoldenTicket,
    Complete,
]);
